<template>
  <div id="v-html-text">
    <div class="bc-simple-content bc-simple-content-sb" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'HtmlText',
  props: {
    content: { type: String, default: '' }
  }
};
</script>

<style>
/* 여긴 scoped를 먹이면 적용이 안됨. */
#v-html-text {
  overflow-x: auto;
}

@media screen and (min-width: 1200px) {
  #v-html-text table {
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
    word-wrap: break-word;
  }
}

@media screen and (max-width: 1199.98px) {
  #v-html-text table {
    width: 100%;
    max-width: 100%;
    word-wrap: break-word;
  }
}

#v-html-text {
  overflow-x: auto;
}
</style>
